import React, { useEffect, useState, useCallback } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import cssClasses from "./CrmTimeLineModal.module.css";
import Close from "../../../../Components/Icons/Close";
import Button from "../../../../Subcomponents/Button";
import { errorTost, offlineToast } from "../../../../Services/Toast";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import DoneIcon from "@mui/icons-material/Done";
import LeadStatusChip from "../../../../Subcomponents/LeadStatusChip";

//icons
import PaymentIcon from "../../../../Components/Icons/PaymentIcon";
import Call from "../../../../Components/Icons/Call";
import SiteVisitIcon from "../../../../Components/Icons/SiteVisitIcon";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import NoNoteFound from "../../../../Assets/Images/Common/NoNoteFound.svg";
// import RejectedIcon from "../../Components/Icons/RejectedIcon";

import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
//Modal
import CrmAddNote from "../CrmAddNote/CrmAddNote";
//service
import {
  getCrmNotes,
  getLeadStatus,
  getNotes,
} from "../../../../Services/LeadNotes";
import { dismissLoader, presentLoader } from "../../../../Services/loader";
import { Network } from "@capacitor/network";
import {
  getCRMTimelineData,
} from "../../../../Services/AllAllotments";

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
    cursor: "pointer",
  },
  personName: {
    fontFamily: "Inter-SemiBold",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    /* identical to box height, or 150% */

    /* Base/Black */

    color: "#000000",
  },
  id: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.2rem",
    lineheight: "1.8rem",
    /* or 150% */
    /* Gray/500 */
    color: "#667085",
  },
  projects: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.6rem",
    lineheight: "2.4rem",
    color: "#344054",
  },
  blockTitle: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.6rem",
    lineheight: "2.4rem",
    color: " #667085",
  },
  blockValue: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.6rem",
    lineheight: "2.4rem",
    color: "#000000",
    textTransform: "capitalize",
  },
  statusTitle: {
    fontFamily: "Inter-SemiBold",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    /* identical to box height, or 133% */

    /* Gray/900 */

    color: "#101828",
  },
  leadId: {
    fontFamily: "Inter-Regular",
    fonStyle: "normal",
    fonWeight: "400",
    fontSize: "1.2rem",
    lineHeight: "1.8rem",
    color: " #667085",
  },
}));

export default function CrmTimeLineModal({ open, data, handleClose }) {
  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [notes, setNotes] = useState([]);
  const [addNoteModal, setAddNoteModal] = useState(false);
  //do chenge it to false when get data from backend
  const [noNotesFound, setNoNotesFound] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [loadingStatus, setLoadingStatus] = useState(0);
  const [listItemsContainerRef, setListItemsContainerRef] = useState();
  const [state, setState] = useState({});
  const project_name = data?.project_name ? data?.project_name : data?.projectname;
  const wing_name = data?.wing_name ? data?.wing_name : data?.wingname;
  const unit_no = data?.unit_no ? data?.unit_no : data?.unitno;
  const title = data?.lead_name ? data?.lead_name : data?.leadname;
  const Subtitle = data?.leaddisplayid;
  const onlistItemsContainerRefChange = useCallback((node) => {
    if (node !== null) {
      setListItemsContainerRef(node);
    }
  }, []);
  useEffect(() => {
    getAllNotes(0);
  }, []);
  function getAllNotes(_pageNumber) {
    Network.getStatus().then((status) => {
      if (status.connected) {
        Promise.all([
          getCrmNotes(
            data.allotment_payment_id ? data.allotment_payment_id : data.allotmentpaymentid,
            data.crmuserid,
            _pageNumber * pageSize,
            _pageNumber * pageSize + pageSize - 1
          ),
          getNotes(
            data.lead_id ? data.lead_id : data.leadid,
            loggedInUser.userId,
            _pageNumber * pageSize,
            _pageNumber * pageSize + pageSize - 1
          ),
        ])
          .then(([crmNotesResp, notesResp]) => {
            const combinedNotes = [...crmNotesResp.data, ...notesResp.data];
            combinedNotes.sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
            const anyNotesFound = combinedNotes.length > 0;
            setNoNotesFound(anyNotesFound);
            setNotes(combinedNotes);
            const anyMoreCrmNotes =
              crmNotesResp.count > crmNotesResp.data.length;
            const anyMoreNotes = notesResp.count > notesResp.data.length;
            if (anyMoreCrmNotes || anyMoreNotes) {
              setLoadingStatus(0);
              setPageNumber(1);
            } else {
              setLoadingStatus(-1);
              setPageNumber(0);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        offlineToast();
      }
    });
  }

  function getMoreData() {
    if (loadingStatus !== 0) return;
    setLoadingStatus(1);
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        const promises = [
          getNotes(
            data.lead_id,
            loggedInUser.userId,
            pageNumber * pageSize,
            pageNumber * pageSize + pageSize - 1
          ),
          getCrmNotes(
            data.allotment_payment_id,
            data.crmuserid,
            pageNumber * pageSize,
            pageNumber * pageSize + pageSize - 1
          ),
        ];

        Promise.all(promises)
          .then(([notesResp, crmNotesResp]) => {
            dismissLoader();

            const combinedNotes = [
              ...notes,
              ...notesResp.data,
              ...crmNotesResp.data,
            ];

            combinedNotes.sort(
              (a, b) => new Date(b.created_time) - new Date(a.created_time)
            );
            setNotes(combinedNotes);

            const anyMoreNotes = notesResp.count > notesResp.data.length;
            const anyMoreCrmNotes =
              crmNotesResp.count > crmNotesResp.data.length;
            if (anyMoreNotes || anyMoreCrmNotes) {
              setPageNumber(pageNumber + 1);
            } else {
              setPageNumber(0);
            }
            if (!anyMoreNotes && !anyMoreCrmNotes) {
              setNoNotesFound(true);
            }
          })
          .catch((error) => {
            dismissLoader();
            console.error(error);
            errorTost(error.message);
          });
      } else {
        offlineToast();
      }
    });
  }

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  // Get day name
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  function closeModal() {
    handleClose();
  }

  useEffect(() => {
    if (data) {
      function getCRMTimeLineNotesModalData(d) {
        presentLoader();
    
        Promise.all([
          getLeadStatus(d?.lead_id ? d?.lead_id : d?.leadid),
          getCRMTimelineData(d?.allotment_payment_id ? d?.allotment_payment_id : d?.allotmentpaymentid),
        ])
        .then(([leadStatusData, timelineData]) => {
            dismissLoader();
            
            const combinedData = {
                data: [...leadStatusData?.data, ...timelineData?.data],
            };
    
            // Sort the combined data in descending order based on the timestamp
            combinedData.data.sort((a, b) => {
                return new Date(b.created_at) - new Date(a.created_at);
            });
    
            setState(combinedData);
        })
        .catch((error) => {
            console.error("Error:", error);
            dismissLoader();
        });
    }
    
    getCRMTimeLineNotesModalData(data);
    
    }
  }, [data]);
  function returnResFromNote(value) {
    if (value) {
      setPageNumber(0);
      setLoadingStatus(0);
      setNotes([]);
      getAllNotes(0);
    }
  }
  return (
    <Modal
      open={open}
      onClose={() => { }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
      // button
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.header}>
            <div className={cssClasses.headerTitle}>
              <div>Timeline And Notes</div>
            </div>
            <span
              className={classes.closeIcon}
              onClick={closeModal}
              tabIndex={0}
            >
              <Close width={"1.5rem"} height={"1.5rem"} />
            </span>
          </div>
          <div className={cssClasses.content}>
            <div className={cssClasses.wrapperFirstRow}>
              <div className={cssClasses.wrapperNameProjects}>
                <div className={cssClasses.block}>
                  <span className={classes.personName}>{title}</span>
                  <span className={classes.leadId}>
                    {"VJ" +
                      Subtitle?.toString()?.replace(
                        Subtitle?.toString()?.substring(8, 12),
                        "-" + Subtitle?.toString()?.substring(8, 12)
                      )}
                  </span>
                </div>
                <div className={cssClasses.block}>
                  <div className={classes.projects}>
                    {project_name}|{wing_name}
                    {"-"}
                    {unit_no}
                  </div>
                </div>
              </div>
            </div>
            <div className={cssClasses.wrapperSecondRow}>
              <div className={cssClasses.wrapperStatusLeftSide}>
                <div className={cssClasses.wrapperStatus}>
                  <div className={classes.statusTitle}>STATUS</div>
                  <div className={cssClasses.progressCardWrapper}>
                    {state?.data?.map((data, index) => {
                      const createdAt = new Date(data.created_at);
                      const dayName = days[createdAt.getDay()];

                      const monthName = months[createdAt.getMonth()];

                      // Format the date
                      const formattedDate = `${dayName} ${monthName} ${createdAt.getDate()} ${createdAt.getFullYear()} ${createdAt.toLocaleTimeString()}`;

                      return (
                        <Timeline
                          position="right"
                          sx={[
                            {
                              padding: "0rem !important",
                              [`& .MuiTimeline-root `]: {
                                padding: "0rem !important",
                              },

                              "& . MuiTypography-root": {
                                padding: "19px 16px !important",
                              },
                              [`& .MuiTimelineItem-root:before`]: {
                                flex: "0rem !important",
                                padding: "0rem !important",
                                "-webkitFlex": "none !important",
                                //  content:'none '
                              },
                            },
                          ]}
                        >
                          <TimelineItem key={index} 
                            color={index === 0 ? `primary` : "grey"}
                          >
                            <TimelineSeparator>
                              <TimelineDot
                                sx={{
                                  backgroundColor: "rgba(11, 165, 236, 0.3)",
                                }}
                              >
                                <DoneIcon />
                              </TimelineDot>
                              {/* Conditionally render TimelineConnector */}
                              {index < state?.data.length - 1 && (
                                <TimelineConnector />
                              )}
                            </TimelineSeparator>
                            <TimelineContent sx={{ py: "12px", px: 2 }}>
                              <Typography variant="h5" component="span"
                                style={{
                                  fontSize: "1.4rem",
                                  fontFamily: "Inter-Medium",
                                  color: "#000000",
                                  lineHeight: "2rem",
                                  verticalAlign: "middle",
                                  marginRight: "0.5rem",
                                }}
                              >
                                {data?.crmStatus ? data?.crmStatus : data?.leadStatus}
                              </Typography>
                              <Typography variant="h6" style={{
                                  fontSize: "1.4rem",
                                  fontFamily: "Inter-Medium",
                                  color: "#667085",
                                  lineHeight: "2rem",
                                  verticalAlign: "middle",
                                  marginRight: "0.5rem",
                                }}>{data.message}</Typography>
                              {/* {created_at= new Date(data.created_at) } */}
                              <Typography style={{
                                  fontSize: "1.4rem",
                                  fontFamily: "Inter-Medium",
                                  color: "#475467",
                                  lineHeight: "1.8rem",
                                  verticalAlign: "middle",
                                  marginRight: "0.5rem",
                                  marginBottom: "0.5rem",
                                  marginTop: "0.5rem",
                                }}>{formattedDate}</Typography>
                            </TimelineContent>
                          </TimelineItem>
                        </Timeline>
                      );
                    })}

                  </div>
                </div>
                
              </div>
              <div className={cssClasses.wrapperAddNotesRightSide}>
                <div className={cssClasses.wrapperNotesAndButton}>
                  <span className={classes.statusTitle}>NOTES</span>
                  <span>
                    <Button
                      style={{
                        color: "#ffffff",
                        backgroundColor: "#155EEF",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        fontFamily: "Inter-Medium",
                      }}
                      btnName={"+ ADD NEW NOTE"}
                      clicked={() => {
                        setAddNoteModal(true);
                      }}
                    />
                  </span>
                </div>
                <div
                  className={cssClasses.wrapperNotesCard}
                  id="scrollableDiv"
                  ref={onlistItemsContainerRefChange}
                >
                  {listItemsContainerRef && (
                    <InfiniteScroll
                      dataLength={notes.length}
                      next={getMoreData}
                      style={{ display: "flex", flexDirection: "column" }} //To put endMessage and loader to the top.
                      hasMore={loadingStatus === 0}
                      // loader={<h4>Loading...</h4>}
                      scrollableTarget={listItemsContainerRef}
                    >
                      {notes.map((note, index) => {
                        return (
                          <div key={index}>
                            <div className={cssClasses.wrapperChips}>
                              {note.noteType === "Call" && (
                                <LeadStatusChip
                                  style={{
                                    color: "#027A48",
                                    backgroundColor: "#ECFDF3",
                                  }}
                                  label={note.noteType}
                                  icon={<Call width={"1rem"} height={"1rem"} />}
                                />
                              )}
                              {note.noteType === "Site Visit" && (
                                <LeadStatusChip
                                  style={{
                                    color: "#3538CD",
                                    backgroundColor: "#EEF4FF",
                                  }}
                                  label={note.noteType}
                                  icon={
                                    <SiteVisitIcon
                                      width={"1rem"}
                                      height={"1rem"}
                                    />
                                  }
                                />
                              )}
                              {note.noteType === "Payment Link Sent" && (
                                <LeadStatusChip
                                  style={{
                                    color: "#B54708",
                                    backgroundColor: "#EEF4FF",
                                  }}
                                  label={note.noteType}
                                  icon={
                                    <PaymentIcon
                                      width={"1rem"}
                                      height={"1rem"}
                                    />
                                  }
                                />
                              )}
                              <div className={cssClasses.callType}>
                                {note.callType}
                              </div>
                              <div className={cssClasses.wrapperContainer}>
                                <div
                                  className={cssClasses.wrapperTime}
                                  style={{ color: "#101828" }}
                                >
                                  <CalendarTodayOutlinedIcon
                                    style={{ color: "#1018289" }}
                                  />
                                  {/* <p className={cssClasses.lastUpdatedText}>Last Updated :</p> */}
                                </div>

                                <div
                                  className={cssClasses.lastUpdatedText}
                                  style={{
                                    color: "#344054",
                                    marginLeft: "1rem",
                                  }}
                                >
                                  <p>
                                    {new Date(note.created_at).toDateString()},{" "}
                                    {new Date(
                                      note.created_at
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className={cssClasses.notesTitle}>
                              {note.title}
                            </div>
                            <div className={cssClasses.notesSubTitle}>
                              {note.description}
                            </div>
                            <div className={cssClasses.border}></div>
                          </div>
                        );
                      })}
                      {noNotesFound === false && (
                        <div className={cssClasses.wrapperNoNotesFound}>
                          <img src={NoNoteFound} alt={"No note Found"} />
                          <span className={cssClasses.noNotesText}>
                            No notes found
                          </span>
                        </div>
                      )}
                    </InfiniteScroll>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {addNoteModal && (
          <CrmAddNote
            open={addNoteModal}
            handleClose={() => {
              setAddNoteModal(false);
            }}
            // data={data}
            returnRes={returnResFromNote}
            allotment_payment_id={data.allotment_payment_id ? data.allotment_payment_id : data.allotmentpaymentid}
            crmuserid={data.crmuserid}
          />
        )}
      </Box>
    </Modal>
  );
}
